export default {
    show: 'Show',
    entries: 'entries',
    previous: 'Previous',
    next: 'Next',
    of: 'of',
};
